'use strict';

var FILE_EXAMPLES = {
    'vekt-tag': [{
        label: 'Eksempel på ID-Vekt tag',
        text: 'Denne finner man i døråpning eller enden av dørblad på førerdør. Gjelder de fleste bilmodeller.\n\nInneholder: VIN, GVWR og GAWR.',
        image: '/images/teknisk/ID-Vekt Tag Eksempel.png'
    }, {
        label: 'Eksempel på Dekk tag',
        text: 'Denne er ofte lokalisert ved siden av ID tag i åpning eller på dørblad på førerdør.\n\nInneholder: Dekkdimensjoner og lufttrykk.',
        image: '/images/teknisk/Dekk Tag Eksempel.png'
    }],
    'window-sticker': [{
        label: 'Eksempel på window sticker',
        text: 'Window Sticker (også kalt Monroney Label) er den originale informasjonsetiketten som ble festet i sidevinduet på nye biler ved salg hos forhandler.\n\nDen viser bilens fabrikkspesifikasjoner, inkludert utstyrsnivå, motor, girkasse, ekstrautstyr, drivstofføkonomi, pris og bilens VIN/chassisnummer.\n\nFor veterankjøretøy og dokumentasjonssaker brukes en window sticker ofte som bevis på hvordan bilen var utstyrt da den forlot fabrikken, samt hvilke fabrikkmonterte tilvalg den hadde.',
        image: '/images/teknisk/Window Sticker Eksempel.png'
    }],
    'rpo-tag': [{
        label: 'Eksempel GM Hengervekt tag',
        text: 'Også lokalisert i døråpning eller dørblad på førerdør.\n\nInneholder: Hengervekt og kulehode kapasitet (eksisterer kun etter 2019 GM).',
        image: '/images/teknisk/Vekt tag GM Hengervekt Tag Eksempel.png'
    }, {
        label: 'GM RPO Tag Eksempel',
        text: 'Stort sett lokalisert i hanskerom for de flest modeller. Noen Camaro og Corvette modeller har den lokalisert i midtkonsoll eller bagasjerom.\n\nInneholder: Alle RPO koder for ekstrautstyr fra fabrikk.',
        image: '/images/teknisk/RPO Tag Eksempel.png'
    }],
    'id-body-tag': [{
        label: 'Eksempel ID Tag',
        text: 'Lokalisert på A-stolpe i førerdør åpning.\n\nInneholder: VIN, vektinformasjon og produksjonsdata.',
        image: '/images/teknisk/Eldre ID Tag Eksempel.png'
    }, {
        label: 'Eksempel Body Tag',
        text: 'Ofte plassert øverst på torpedovegg mot førerside.\n\nInneholder: Fargekode, trimkode og produksjonsinformasjon.',
        image: '/images/teknisk/Eldre kjøretøy Body Tag Eksempel.png'
    }, {
        label: 'GM RPO Tag Eksempel',
        text: 'Stort sett lokalisert i hanskerom for de flest modeller. Noen Camaro og Corvette modeller har den lokalisert i midtkonsoll eller bagasjerom.\n\nInneholder: Alle RPO koder for ekstrautstyr fra fabrikk.',
        image: '/images/teknisk/RPO Tag Eksempel.png'
    }],
    'tags': [{
        label: 'Eksempel på ID-Vekt tag',
        text: 'Denne finner man i døråpning eller enden av dørblad på førerdør. Gjelder de fleste bilmodeller.\n\nInneholder: VIN, GVWR og GAWR.',
        image: '/images/teknisk/ID-Vekt Tag Eksempel.png'
    }, {
        label: 'Eksempel ID Tag',
        text: 'Lokalisert på A-stolpe i førerdør åpning.\n\nInneholder: VIN, vektinformasjon og produksjonsdata.',
        image: '/images/teknisk/Eldre ID Tag Eksempel.png'
    }, {
        label: 'GM RPO Tag Eksempel',
        text: 'Stort sett lokalisert i hanskerom for de flest modeller. Noen Camaro og Corvette modeller har den lokalisert i midtkonsoll eller bagasjerom.\n\nInneholder: Alle RPO koder for ekstrautstyr fra fabrikk.',
        image: '/images/teknisk/RPO Tag Eksempel.png'
    }],
    'rpo-tag-hengervekt': [{
        label: 'Eksempel GM Hengervekt tag',
        text: 'Også lokalisert i døråpning eller dørblad på førerdør.\n\nInneholder: Hengervekt og kulehode kapasitet (eksisterer kun etter 2019 GM).',
        image: '/images/teknisk/Vekt tag GM Hengervekt Tag Eksempel.png'
    }, {
        label: 'GM RPO Tag Eksempel',
        text: 'Stort sett lokalisert i hanskerom for de flest modeller. Noen Camaro og Corvette modeller har den lokalisert i midtkonsoll eller bagasjerom.\n\nInneholder: Alle RPO koder for ekstrautstyr fra fabrikk.',
        image: '/images/teknisk/RPO Tag Eksempel.png'
    }]
};

var app = new Vue({
    el: '#regdata-bestilling-app',
    data: {
        // Member access
        isMember: window.TechnicalFormConfig ? window.TechnicalFormConfig.isMember : false,
        loginUrl: window.TechnicalFormConfig ? window.TechnicalFormConfig.loginUrl : '/Account/Login',
        registerUrl: window.TechnicalFormConfig ? window.TechnicalFormConfig.registerUrl : '/bli-medlem',

        // State
        currentStep: 1,
        loading: false,
        errors: {},

        // Step 1: Vehicle age type
        vehicleAgeType: null,

        // Contact info
        memberNumber: '',
        name: '',
        address: '',
        zipCode: '',
        city: '',
        phone: '',
        email: '',

        // Vehicle info
        vinNumber: '',
        carMake: '',
        carModel: '',
        constructionYear: '',
        engineVolume: '',
        engineEffect: '',
        selectedTransmission: '',
        importland: '',

        // Tire/wheel dimension fields (used for both newer and older vehicles)
        wheelsFront: '',
        rimFront: '',
        wheelsBehind: '',
        rimBehind: '',

        // Newer vehicle fields
        gvwr: '',
        gawrFront: '',
        gawrRear: '',

        // Yes/No questions
        wantsTrailerWeightCheck: null,
        isOriginal: null,
        nonOriginalDescription: '',
        isElectric: null,
        hasWindowStickerAnswer: null,
        acceptsWindowStickerPurchase: null,
        hasCarfax: null,
        wantsCarfax: null,

        // Hengervekt specific fields
        vinOrRegNumber: '',
        engine: '',
        isGmVehicle: null,

        // File uploads - stored locally until form submission
        localFiles: [],

        // Other comments
        otherComments: '',

        // Example image modal
        activeExamples: null
    },
    computed: {
        hasWindowSticker: function hasWindowSticker() {
            return this.localFiles.some(function (f) {
                return f.type === 'window-sticker';
            });
        },
        vektTagFiles: function vektTagFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'vekt-tag';
            });
        },
        idBodyTagFiles: function idBodyTagFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'id-body-tag';
            });
        },
        rpoTagFiles: function rpoTagFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'rpo-tag';
            });
        },
        windowStickerFiles: function windowStickerFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'window-sticker';
            });
        },
        tagsFiles: function tagsFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'tags';
            });
        },
        rpoTrailerFiles: function rpoTrailerFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'RPO-tag';
            });
        },
        carfaxDocsFiles: function carfaxDocsFiles() {
            return this.localFiles.filter(function (f) {
                return f.type === 'carfax-docs';
            });
        }
    },
    watch: {
        hasCarfax: function hasCarfax(newVal) {
            if (newVal === true) {
                this.wantsCarfax = null;
            }
        }
    },
    mounted: function mounted() {
        var self = this;
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && self.activeExamples) {
                self.closeExamples();
            }
        });
    },
    methods: {
        showExamples: function showExamples(fileType) {
            this.activeExamples = FILE_EXAMPLES[fileType] || null;
            if (this.activeExamples) {
                document.body.style.overflow = 'hidden';
            }
        },
        closeExamples: function closeExamples() {
            this.activeExamples = null;
            document.body.style.overflow = '';
        },
        toggleZoom: function toggleZoom(event) {
            event.target.classList.toggle('zoomed');
        },
        selectVehicleType: function selectVehicleType(type) {
            if (!this.isMember) return;
            this.vehicleAgeType = type;
            this.currentStep = 2;
        },
        nextStep: function nextStep() {
            if (this.currentStep === 1 && this.vehicleAgeType) {
                this.currentStep = 2;
            }
        },
        prevStep: function prevStep() {
            if (this.currentStep > 1) {
                this.currentStep = 1;
                this.vehicleAgeType = null;
            }
        },
        validateForm: function validateForm() {
            this.errors = {};

            // Required contact fields (same for all types)
            if (!this.memberNumber) this.errors.memberNumber = 'Du må fylle ut medlemsnummer';
            if (!this.name) this.errors.name = 'Du må fylle ut navn';
            if (!this.address) this.errors.address = 'Du må fylle ut adresse';
            if (!this.zipCode) this.errors.zipCode = 'Du må fylle ut postnummer';
            if (!this.city) this.errors.city = 'Du må fylle ut poststed';
            if (!this.phone) this.errors.phone = 'Du må fylle ut telefonnummer';
            if (!this.email) this.errors.email = 'Du må fylle ut e-postadresse';

            // Email validation
            if (this.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.errors.email = 'Ugyldig e-postadresse';
            }

            // Hengervekt specific validation
            if (this.vehicleAgeType === 'hengervekt') {
                if (!this.vinOrRegNumber) this.errors.vinOrRegNumber = 'Du må fylle ut VIN eller reg.nr.';
                if (!this.carMake) this.errors.carMake = 'Du må fylle ut bilmerke';
                if (!this.carModel) this.errors.carModel = 'Du må fylle ut modellbetegnelse';
                if (!this.constructionYear) this.errors.constructionYear = 'Du må fylle ut årsmodell';
                if (!this.engine) this.errors.engine = 'Du må fylle ut motor';
                if (!this.selectedTransmission) this.errors.selectedTransmission = 'Du må velge girtype';

                var hasTags = this.localFiles.some(function (f) {
                    return f.type === 'tags';
                });
                if (!hasTags) this.errors.tags = 'Du må laste opp tags';

                if (this.isGmVehicle === true) {
                    var hasRpoTrailer = this.localFiles.some(function (f) {
                        return f.type === 'RPO-tag';
                    });
                    if (!hasRpoTrailer) this.errors.rpoTrailer = 'Du må laste opp RPO tag / trailer tag for GM-kjøretøy';
                }
            } else {
                // Newer/Older vehicle validation
                if (!this.vinNumber) this.errors.vinNumber = 'Du må fylle ut VIN-nummer';
                if (!this.carMake) this.errors.carMake = 'Du må fylle ut bilmerke';
                if (!this.carModel) this.errors.carModel = 'Du må fylle ut modellbetegnelse';
                if (!this.constructionYear) this.errors.constructionYear = 'Du må fylle ut årsmodell';
                if (!this.selectedTransmission) this.errors.selectedTransmission = 'Du må velge girtype';
                if (!this.importland) this.errors.importland = 'Du må fylle ut importland';

                // Tire/wheel fields required for both newer and older
                if (!this.wheelsFront) this.errors.wheelsFront = 'Du må fylle ut dekk foran';
                if (!this.rimFront) this.errors.rimFront = 'Du må fylle ut felg foran';
                if (!this.wheelsBehind) this.errors.wheelsBehind = 'Du må fylle ut dekk bak';
                if (!this.rimBehind) this.errors.rimBehind = 'Du må fylle ut felg bak';

                // Required yes/no questions
                if (this.wantsTrailerWeightCheck === null) this.errors.wantsTrailerWeightCheck = 'Du må svare på dette spørsmålet';
                if (this.isOriginal === null) this.errors.isOriginal = 'Du må svare på dette spørsmålet';

                // Newer vehicle specific validations
                if (this.vehicleAgeType === 'newer') {
                    if (!this.gvwr) this.errors.gvwr = 'Du må fylle ut GVWR';
                    if (!this.gawrFront) this.errors.gawrFront = 'Du må fylle ut GAWR Front';
                    if (!this.gawrRear) this.errors.gawrRear = 'Du må fylle ut GAWR Rear';

                    if (this.hasCarfax === null) this.errors.hasCarfax = 'Du må svare på dette spørsmålet';
                    if (this.hasCarfax === true) {
                        var hasCarfaxDocs = this.localFiles.some(function (f) {
                            return f.type === 'carfax-docs';
                        });
                        if (!hasCarfaxDocs) this.errors.carfaxDocs = 'Du må laste opp carfax dokumentasjon';
                    }
                    if (this.hasCarfax === false && this.wantsCarfax === null) this.errors.wantsCarfax = 'Du må svare på dette spørsmålet';

                    // Check file upload for newer vehicles
                    var hasVektTag = this.localFiles.some(function (f) {
                        return f.type === 'vekt-tag';
                    });
                    if (!hasVektTag) this.errors.vektTag = 'Du må laste opp vekt tag / dekk tag';
                }

                // Older vehicle specific validations
                if (this.vehicleAgeType === 'older') {
                    var hasIdBodyTag = this.localFiles.some(function (f) {
                        return f.type === 'id-body-tag';
                    });
                    if (!hasIdBodyTag) this.errors.idBodyTag = 'Du må laste opp ID tag og body tag';
                }
            }

            return Object.keys(this.errors).length === 0;
        },
        handleFileUpload: function handleFileUpload(event, fileType) {
            var files = event.target.files;
            if (!files || files.length === 0) return;

            var MAX_TOTAL_SIZE_BYTES = 52428800;
            var currentTotal = this.localFiles.reduce(function (sum, f) {
                return sum + f.file.size;
            }, 0);
            var incoming = 0;
            for (var j = 0; j < files.length; j++) {
                incoming += files[j].size;
            }
            if (currentTotal + incoming > MAX_TOTAL_SIZE_BYTES) {
                alert('Filene er for store. Maks totalstørrelse er 50 MB.');
                event.target.value = '';
                return;
            }

            // Store files locally - will be uploaded on form submission
            for (var i = 0; i < files.length; i++) {
                this.localFiles.push({
                    file: files[i],
                    name: files[i].name,
                    type: fileType
                });
            }

            // Clear the input so the same file can be uploaded again if needed
            event.target.value = '';
        },
        removeFile: function removeFile(file) {
            var index = this.localFiles.indexOf(file);
            if (index > -1) {
                this.localFiles.splice(index, 1);
            }
        },
        submitForm: function submitForm() {
            var self = this;
            if (!this.validateForm()) {
                // Scroll to first error
                var firstError = document.querySelector('.text-danger');
                if (firstError) {
                    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }

            this.loading = true;

            // Build FormData for multipart submission
            var formData = new FormData();

            // Common contact fields
            formData.append('vehicleAgeType', this.vehicleAgeType);
            formData.append('memberNumber', this.memberNumber);
            formData.append('name', this.name);
            formData.append('address', this.address);
            formData.append('zipCode', this.zipCode);
            formData.append('city', this.city);
            formData.append('phone', this.phone);
            formData.append('email', this.email);

            if (this.vehicleAgeType === 'hengervekt') {
                // Hengervekt specific fields
                formData.append('vinOrRegNumber', this.vinOrRegNumber);
                formData.append('carMake', this.carMake);
                formData.append('carModel', this.carModel);
                formData.append('constructionYear', this.constructionYear);
                formData.append('engine', this.engine);
                formData.append('selectedTransmission', this.selectedTransmission);
                formData.append('isGmVehicle', this.isGmVehicle || false);
                formData.append('otherComments', this.otherComments || '');
            } else {
                // Newer/Older vehicle fields
                formData.append('vinNumber', this.vinNumber);
                formData.append('carMake', this.carMake);
                formData.append('carModel', this.carModel);
                formData.append('constructionYear', this.constructionYear);
                formData.append('engineVolume', this.engineVolume || '');
                formData.append('engineEffect', this.engineEffect || '');
                formData.append('selectedTransmission', this.selectedTransmission);
                formData.append('importland', this.importland || '');
                formData.append('wheelsFront', this.wheelsFront || '');
                formData.append('rimFront', this.rimFront || '');
                formData.append('wheelsBehind', this.wheelsBehind || '');
                formData.append('rimBehind', this.rimBehind || '');
                formData.append('gvwr', this.gvwr || '');
                formData.append('gawrFront', this.gawrFront || '');
                formData.append('gawrRear', this.gawrRear || '');
                formData.append('wantsTrailerWeightCheck', this.wantsTrailerWeightCheck);
                formData.append('isOriginal', this.isOriginal);
                formData.append('nonOriginalDescription', this.nonOriginalDescription || '');
                formData.append('isElectric', this.isElectric !== null ? this.isElectric : '');
                formData.append('hasWindowStickerAnswer', this.hasWindowStickerAnswer !== null ? this.hasWindowStickerAnswer : '');
                formData.append('acceptsWindowStickerPurchase', this.acceptsWindowStickerPurchase !== null ? this.acceptsWindowStickerPurchase : '');
                formData.append('hasCarfax', this.hasCarfax !== null ? this.hasCarfax : '');
                formData.append('wantsCarfax', this.wantsCarfax !== null ? this.wantsCarfax : '');
                formData.append('otherComments', this.otherComments || '');
            }

            // Add files with type-prefixed names
            this.localFiles.forEach(function (fileObj) {
                formData.append('files-' + fileObj.type, fileObj.file, fileObj.name);
            });

            axios.post('/teknisk/regdata-bestilling', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(function () {
                window.location.href = '/teknisk/skjema/takk?skjema=' + encodeURIComponent(window.location.pathname);
            }).catch(function (error) {
                alert('En feil oppstod ved innsending av skjemaet. Vennligst prøv igjen.');
                console.error('Submission failed:', error);
                self.loading = false;
            });
        }
    }
});